import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import LoadingPage from '../../components/LoadingPage';
import { db } from '../../../config/Fire';
import * as Constants from '../../../constants';
import { getUser } from '../../../reducers';
import Chats from '../../components/Chats';
import './styles.css';

const ChatHistoricalClient = props => {
    const[historicalProcedures, setHistoricalProcedures] = useState(null)

    const getHistoricalProcedures = user => {
        console.log("getHistoricalProcedures client")
        db.ref(`${Constants.MAIN_NODES.HISTORICAL_PROCEDURES}`).orderByChild("userId").equalTo(`${user.id}`).once("value")
        .then(snapProcedures => {
            if(snapProcedures.exists()) {
                const proceduresMap = {}
                snapProcedures.forEach(procedureSnap => {
                    const procedure = procedureSnap.val();
                    proceduresMap[procedure.id] = procedure;
                });
                setHistoricalProcedures(proceduresMap)
            } else {
                setHistoricalProcedures({})
            }
        })
        return <LoadingPage />
    }

    return (
        <div className="chatHistoricalClientCont">
            {
                props.user ?
                    historicalProcedures !== null ?
                        <Chats procedures={historicalProcedures} enableChat={false} />
                        :
                        getHistoricalProcedures(props.user)
                    :
                    <LoadingPage />
            }
        </div>
    );
};

ChatHistoricalClient.propTypes = {
    
};

const mapDispatchToPropsActions = dispatch => ({
    
});

const mapStateToProps = state => ({ 
    user:  getUser(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ChatHistoricalClient));